import { memo } from 'react';
import { Box } from '@bonanza-social/moonlight';
import { PrizeWallWinnersFeedIndicatorProps } from './PrizeWallWinnersFeedIndicator.types';

function PrizeWallWinnersFeedIndicator(
  props: PrizeWallWinnersFeedIndicatorProps,
) {
  return (
    <Box
      width={14}
      height={14}
      borderRadius="radius-full"
      backgroundColor="tertiaryBackgroundDisabled"
      centerContent
      {...props}
    >
      <Box
        width={10}
        height={10}
        borderRadius="radius-full"
        backgroundColor="tertiaryBackgroundDisabled"
        centerContent
      >
        <Box
          width={4}
          height={4}
          borderRadius="radius-full"
          variant="gradient"
        />
      </Box>
    </Box>
  );
}

export default memo(PrizeWallWinnersFeedIndicator);
